import { Color } from "csstype";
import { IComponent } from "./component";
declare global {
  interface Window {
    islogin: boolean;
    isweixin: boolean;
    isweixinweb: boolean;
    isweixinwork: boolean;
    isdev: boolean;
    // __current_gallery__: {
    //   useglobal: string;
    // };
    __webpack_public_path__: string;
    configDetail: IConfigDetail;
    pageDetail: IPageDetail;
    gallery: IGallery;
    dataDetail?: IDataDetail;
    exhibitorInfo?: IExhibitorInfo; // 展商信息（仅展商详情页）
    wx: any;
    __wxjs_environment?: string; // 当前环境，参考相关代码
    has_config_share: boolean;
    videojs: (name: any, options?: any, callback?: any) => any;
    WeixinJSBridge: any;
    ActiveXObject: any;
    userinfo: any;
    original_photo: boolean;
    custom_watermarks?: any;
    custom_current_watermark?: any;
    match_params?: any;
    __player?: any;
    TIM: any;
    Aliplayer: any;
    AliPlayerComponent: any;
    CommentManager: any;
    WxLogin: any;
    JSZip: any;
    appendScript: (url: string) => void;
    weui: any;
    pingpp: any;
    __hostname: string;
    __basename: string;
    // 是否支持webp
    __isSupportWebp: boolean;
    visitParentLinkId?: string;
    __stat: any;
    _t: number;
    // 海报分享，第二个模板，显示观看人数
    __share_show_view?: boolean;
    // 海报分享，固定分享主链接
    __share_use_root?: boolean;

    // 全局的本地化
    __locales?: {
      [key: string]: any;
    };

    // 使用当前域名作为图片加载域
    __use_custom_image?: boolean;

    // 禁用分享
    __disable_share?: boolean;
  }
  interface TouchEvent {
    currentTarget: any;
    target: {
      clientWidth: number;
      parentNode: any;
    };
  }
  interface Event {
    action?: string;
    buttons?: IOneButton[];
    eventType?: string;
    data?: any;
    cid?: any;
  }
  interface Document {
    webkitFullscreenElement?: any;
  }
}
export interface IError {
  data: {
    error: string;
  };
}
export interface IResult {
  success?: boolean;
  data?: any;
  [key: string]: any;
}
export interface IListResult extends IResult {
  data: any[];
  total: number;
  watermarks?: any;
}

export enum IconType {
  img,
  span,
}
export interface IOneIcon {
  icon?: string;
  type?: IconType;
  className?: string;
}

/* ConfigDetail */
interface IConfigDetailTheme {
  h1: Color; // 主字体颜色
  h2: Color;
  component: Color; // 组件背景色
  background: Color; // 页面背景色
  main: Color; // 主题色
}

enum IAccessType {
  free = "free",
  password = "password",
  phone = "phone",
}

interface IH5Share {
  h5_share_image?: string | null;
  h5_share_text?: string | null;
  h5_share_title?: string | null;
}
interface IMiniAppShare {
  miniapp_share_image?: string | null;
  miniapp_share_text?: string | null;
  miniapp_share_title?: string | null;
}
// gallery_config
export interface IConfigDetail extends IH5Share, IMiniAppShare {
  readonly id: number;
  readonly gallery_id: number; // 相册ID
  readonly active_on: number;
  readonly balance: number | null; // 活动余额
  readonly limit_once: number | null; // 单次红包限额
  readonly access_type?: IAccessType; //访问类型
  readonly sort?: string | null; //排序规则
  //"active_image_type": null;
  //"active_video_type": null;
  //"active_check_type": nul;
  readonly user_batch: string | null; // 白名单情况下，对应的手机号批次号: B2019111111111
  readonly use_global: number; // 是否全球加速
  readonly use_package: number; // 是否开启红包
  readonly use_ocr: number; // 是否OCR
  readonly use_order: number; // 是否显示预约
  use_face: number; // 是否人脸识别
  readonly locale?: string; // 本地化语言 zh-CN/en-US
  readonly use_comment: number; // 是否开启评论
  readonly password: null | string; //access_type为password时，这是密码
  readonly created_at?: string | null;
  readonly updated_at?: string;
  readonly theme: IConfigDetailTheme;
  readonly use_tip?: number | null; // 1表示需要用提示
  readonly download_video?: number | boolean; //1 表示 需要视频的下载按钮
  readonly global_css?: string;
  readonly global_js?: string;
  readonly use_invite_auth?: number;
  readonly use_invite_link?: number;
  readonly use_v_commnet?: number;
  readonly long_config?: any;
  block_all?: number;
  bool_vector?: number;
}

/**
 * PageDetail
 */

export interface IPageDetail {
  readonly id: number; // 自增ID
  readonly type: string; // 界面类型 支持normal/link(三方)/custom(专家模式)
  readonly title: string;
  readonly entrance: number; // 是否为入口界面
  template: IComponent[];
  readonly gallery_id: number; // 相册ID
  readonly data?: string; // 装修里边涉及到的可能有用的数据字段
  readonly parent: string; // 父级界面
  readonly link_id: string; // 混淆ID，此ID作为对外的所有ID显示
  readonly created_at?: string;
  readonly updated_at?: string;
  readonly video_data?: number;
  [name: string]: any;
}

/**
 * Gallery
 * */

export enum IGalleryStatus {
  wait = "wait",
  start = "living",
  end = "end",
  amazing = "amazing",
  rollback = "rollback",
  play = "play",
  stop = "stop",
  config = "config",
  complete = "complete",
  directend = "directend",
  needpay = "needpay",
  payed = "payed",
}
export interface IGallery {
  readonly id: number; // 相册ID
  readonly name: string; // 相册名称
  readonly link: string; //pagedataid
  readonly status: IGalleryStatus;
  readonly parent: number; //父相册ID
  readonly orderid: number; //订单ID
  readonly created_at?: string;
  readonly updated_at?: string;
  readonly tags: string; // 标签，逗号分隔
  readonly start_time: string; //活动开始时间
  readonly end_time: string; //活动结束时间
  readonly prefix: string; //标题前缀
  readonly url_labeling: string;
  readonly galleryaddress?: string;
  readonly privacy?: string;
  readonly praise?: number;
  readonly avchatroom?: string;
  readonly is_pay_down?: number;
  watermarks?: any;
}

export interface IDataDetail {
  watermarks: string;
  id: number;
  link: string;
  name: string;
  status: IGalleryStatus;
  tags: string | null;
  start_time?: string;
  end_time?: string;
  readonly is_pay_down?: number;
  readonly privacy?: string;
}

export interface IViewDetail {
  view: number;
  uv: number;
}

export interface IImageMayBe {
  personid: string;
  imageid: string;
  image: {
    hash: string;
    id: string;
  };
  shape: {
    height: number;
    width: number;
    x: number;
    y: number;
  };
}

export interface IPoint {
  x: number;
  y: number;
}

export interface ISimpleImage {
  id: number;
  hash: string;
}

export interface IUser {
  openid: string;
  originid?: string;
  pc_id?: string;
  is_mock: boolean;
  nickname: string;
  photo: string;
  redirect: string;
  sysinfo: {
    env: string;
    is_pc: number;
    web_appid?: string;
  };
}

export interface IImageSignature {
  accessid: string;
  host: string;
  policy: string;
  signature: string;
  expire: number;
  dir: string;
}

export interface IImageUpload {
  policy?: string;
  OSSAccessKeyId?: string;
  success_action_status?: number;
  callback?: string;
  signature?: string;
  key: string;
  file: any;
}

export interface IPerson {
  faceurl: string;
  id: number;
  name?: string;
  status?: string;
  total_gallery_image: number;
  total_image: number;
  mainColor?: string;
}

// 展商信息接口
export interface IExhibitorInfo {
  id: number;
  order_id: number;
  name: string;
  short_name: string;
  booth: string;
  desc: string;
  contact_person: string;
  contact_person_mobile: string;
  gallery_id: number;
  gallery_pagedata_id: number;
  exhibitor_logo: string | null;
  status: number;
  gallerys_detail?: any;
  gallerys_pagedata_detail?: any;
}

declare global {
  namespace JSX {
    interface IntrinsicElements {
      "wx-open-launch-weapp": any;
    }
  }
}
